import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react'

import { useWizardBreadcrumb } from './useWizard'

export const WizardBreadcrumb = ({ ...props }) => {
  const { steps, currentStep } = useWizardBreadcrumb()

  return (
    <Breadcrumb separator={<ChevronRightIcon color='gray.500' />}>
      {steps.map(({ label, path }, index) => (
        <BreadcrumbItem
          key={index}
          isCurrentPage={currentStep?.path === path}
          textDecoration={currentStep?.path === path ? 'underline' : 'inherit'}>
          <BreadcrumbLink as={Link} to={path}>
            {index + 1}. {label}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  )
}

export default WizardBreadcrumb
